/**
 * Checks if a display model is a browser agent variant.
 * Uses string prefix matching instead of SearchModel enum to avoid pulling
 * search-modes.ts (600+ lines) into bundles that don't otherwise need it.
 */
export function isBrowserAgent(displayModel) {
    if (!displayModel)
        return false;
    return displayModel.startsWith('comet_browser_agent');
}
//# sourceMappingURL=isBrowserAgent.js.map